<div #divWithDir>
    <div *ngIf="!showThanks" class="sendFeedbackContainer">
             <button mat-icon-button  (click)="close()" class="closeBtn">
                    <mat-icon>close</mat-icon>
                </button>

            <span class="sendFeedback_title">{{"sendFeedback.title" | translate}}</span>
            <mat-chip-listbox
                class="example-chip"
                cdkDropList 
                cdkDropListOrientation="horizontal"
                >
                <mat-chip-option class="example-box" cdkDrag (click)="selectIssue(1)">{{"sendFeedback.chip-issue" | translate}}</mat-chip-option>
                <mat-chip-option class="example-box" cdkDrag (click)="selectIssue(2)">{{"sendFeedback.chip-moov" | translate}}</mat-chip-option>
                <mat-chip-option class="example-box" cdkDrag (click)="selectIssue(3)">{{"sendFeedback.chip-other" | translate}}</mat-chip-option>
            </mat-chip-listbox>
            <div class="commentsContainer">
                <span class="text">{{"sendFeedback.addNote" | translate}}</span>
                <mat-form-field appearance="outline">
                    <!-- <mat-label>{{"sendFeedback.addNote" | translate}}</mat-label> -->
                    <textarea matInput class="textFeedback" [(ngModel)]="feedbackText"></textarea>
                </mat-form-field>
            </div>
            <button mat-raised-button class="sendButton" (click)="send()">{{"sendFeedback.send" | translate}}</button>
    </div>
    <div class="sendFeedback_thankYouMessage" *ngIf="showThanks">
            <span class="sendFeedback_title">{{"sendFeedback.sent" | translate}}</span>
            <img class="sendFeedback_thanksImage" src="{{imageCommonFolder}}feddback_sent.svg">
    </div>
</div>